import { MdAddCircle, MdCloudDownload, MdFileCopy } from "react-icons/md";
import { Tooltip } from "antd";
import useModal from "../../hooks/useModal";
import { Icon } from "../Icon";
import { 
    Container,
    PrimaryActions,
    ButtonPrimary,
    SecondaryActions,
    ButtonActions
} from "./styles";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";

export function ActionButtons() {
    const { setIsOpen, setId, setIsCopying, isCopyingObject, setIsOpenImport } = useModal();
    const { hasPermission } = useValidatePermission();

    function handleOpenCopy() {
        if(isCopyingObject.length === 0) return;
        setId('');
        setIsOpen(true);
        setIsCopying(true);
    }

    return (
        <Container>
            <PrimaryActions>
                <Tooltip title={!hasPermission(['PlanoOperacional.Cadastrar']) ? "Você não tem permissão para criar novo planejamento" : undefined} placement="top">
                    <ButtonPrimary disabled={!hasPermission(['PlanoOperacional.Cadastrar'])} onClick={() => {
                        if (!hasPermission(['PlanoOperacional.Cadastrar'])) return;
                        setId('');
                        setIsOpen(true);
                    }}>
                        <Icon icon={MdAddCircle} color="#fff" backgroundColor="#12619C" />
                        Novo Planejamento
                    </ButtonPrimary>
                </Tooltip>
            </PrimaryActions>
            
            <SecondaryActions>
                <Tooltip title={!hasPermission(['PlanoOperacional.Importar']) ? "Você não tem permissão para importar planejamento" : undefined} placement="top">
                    <span style={{ flex: 1 }}>
                        <ButtonActions
                            disabled={!hasPermission(['PlanoOperacional.Importar'])}
                            onClick={() => {
                            if (!hasPermission(['PlanoOperacional.Importar'])) return;
                            setIsOpenImport(true)}
                        }>
                            <Icon icon={MdCloudDownload} />
                            Importar
                        </ButtonActions>
                    </span>
                </Tooltip>
                <Tooltip title={!hasPermission(['PlanoOperacional.Copiar']) ? "Você não tem permissão para copiar planejamento" : undefined} placement="top">
                    <span style={{ flex: 1 }}>
                        <ButtonActions onClick={() => {
                            if (!hasPermission(['PlanoOperacional.Copiar'])) return;
                            handleOpenCopy();
                        }} disabled={isCopyingObject.length === 0 || !hasPermission(['PlanoOperacional.Copiar'])}>
                            <Icon icon={MdFileCopy} />
                            Copiar
                        </ButtonActions>
                    </span>
                </Tooltip>
            </SecondaryActions>
            
      </Container>
    )
}